var map = {
	"./45-percent-com.webp": 1910,
	"./commission.svg": 1911,
	"./country.svg": 1912,
	"./daily-commission.svg": 1913,
	"./earnings-bg.webp": 1914,
	"./global.svg": 1915,
	"./home-banner-cn.webp": 1916,
	"./home-banner.webp": 1917,
	"./home-container.webp": 1918,
	"./join-us.webp": 1919,
	"./zero-risk.webp": 1920
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 636;